export enum REGISTRATION_TYPE {
  INDIVIDUAL = 1,
  SALARIED_AGENT = 2,
  FREELANCER_AGENT = 3,
  COMPANY = 4,
}

export enum USER_TYPE_SLUGS {
  INDIVIDUAL = "individual",
  SALARIED_AGENT = "salaried-agent",
  FREELANCER_AGENT = "freelancer-agent",
  COMPANY = "company",
}
export enum VISA_TYPES {
  TOURIST_VISA = 1,
  STUDY_VISA = 2,
  WORK_VISA = 3,
  BUSINESS_VISA = 4,
}

export enum VISA_TYPES_SLUGS {
  TOURIST_VISA = "tourist-visa",
  STUDY_VISA = "study-visa",
  WORK_VISA = "work-visa",
  BUSINESS_VISA = "business-visa",
}

export enum UPDATE_TYPES {
  BLOCK = "block",
  ACCEPT = "accept",
  REJECT = "reject",
}
export enum APPROVAL_STATUS {
  PENDING = 0,
  APPROVED = 1,
  REJECTED = 2,
}

export enum USER_TYPES {
  INDIVIDUAL = 1,
  COMPANY = 2,
  AGENT = 3,
}
export enum USER_ROLES {
  ADMIN = 1,
  SUBADMIN = 2,
  INDIVIDUAL = 3,
  SALARIED_AGENT = 4,
  FREELANCER_AGENT = 5,
  COMPANY = 6,
}

export const SHOW_USER_ROLES: Record<number, string> = {
  1: "Admin",
  2: "Sub-admin",
  3: "Individual",
  4: "Salaried-Agent",
  5: "Freelancer-Agent",
  6: "Company",
};

export const GENDER_TYPES: Record<number, string> = {
  1: "Male",
  2: "Female",
};
export enum GENDER_STATUS {
  MALE = 1,
  FEMALE = 2,
}

export const MARITAL_STATUS: Record<number, string> = {
  1: "Single",
  2: "Married",
  3: "Divorced",
  4: "Separated",
  5: "Other",
};
export enum MARITAL_STATUS_VALUE {
  SINGLE = 1,
  MARRIED = 2,
  DIVORCED = 3,
  SEPARATED = 4,
  OTHER = 5,
}
export const VISA_TYPE_NAMES: Record<number, string> = {
  1: "Visit Visa",
  2: "Study Visa",
  3: "Work Visa",
  4: "Business Visa",
};

export enum FILTER_TYPES {
  DAILY = "1",
  WEEKLY = "2",
  MONTHLY = "3",
  YEARLY = "4",
}

export enum GRAPH_TYPES {
  USER = 3,
  SALARIED = 4,
  FREELANCER = 5,
  COMPANY = 6,
  APPLICATION = 7,
  TOTAL_REVENUE = 8,
}

export enum APPLICATION_STATUS {
  CONSULTATION_ADDED = 1,
  CONNECT_WITH_VISA_COUNSELLOR = 2,
  DOCUMENT_VERIFIED = 3,
  ASSESSMENT = 4,
  CONTRACT_AND_INITIAL_PAYMENT = 5,
  CHECKLIST_COMPLETION = 6,
  FILE_PREPARATION = 7,
  SCHEDULE_APPOINTMENT = 8,
  LODGEMENT = 9,
  REGISTER_IN_EMBASSY = 10,
}

export const SHOW_APPLICATION_STATUS: Record<number, string> = {
  1: "Consultation Added",
  2: "Connect with Visa Counselor",
  3: "Document Verified",
  4: "Assessment",
  5: "Contract & Initial Payment",
  6: "Checklist Completion",
  7: "File Preparation",
  8: "Schedule Appointment",
  9: "Lodgement",
  10: "Register in Embassy",
};

export enum PAYMENT_STATUS {
  FIRST_MINIMUM_PAYMENT = 0,
  FIRST_FULL_PAYMENT = 1,
  SECOND_PAYMENT = 2,
  THIRD_PAYMENT = 3,
  NO_PAYMENT = 5,
}

export const PAYMENT_STATUS_LABELS: Record<number, string> = {
  [PAYMENT_STATUS.FIRST_MINIMUM_PAYMENT]: "First Payment (Minimum)",
  [PAYMENT_STATUS.FIRST_FULL_PAYMENT]: "First  Payment (Full)",
  [PAYMENT_STATUS.SECOND_PAYMENT]: "Second Payment",
  [PAYMENT_STATUS.THIRD_PAYMENT]: "Third Payment",
  [PAYMENT_STATUS.NO_PAYMENT]: "No Payment",
};
